module.exports = __webpack_public_path__ + "img/logo_coneco.f296ed18.svg";